import { SellerStateEnum } from "./sellerStateEnum";

export const entryTypeOptions = [
  { key: SellerStateEnum.Active, text: "Activo" },
  { key: SellerStateEnum.Inactive, text: "Inactivo" },
];

export const getSellerStateText = (key: number) => {
  return entryTypeOptions.find((type) => type.key === key)?.text || "";
};

export const getSellerState = (text: string) => {
  return entryTypeOptions.find((type) => type.text === text)?.key || 0;
};
